// extracted by mini-css-extract-plugin
export default {"widgetContainer":"Dashboard_widgetContainer__AXjBP","widgetWrapper":"Dashboard_widgetWrapper__GhMbi","widgetWrapperFullWidth":"Dashboard_widgetWrapperFullWidth__xTGs7"};